/* import __COLOCATED_TEMPLATE__ from './phone-handover-goodbye-message.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import { action } from '@ember/object';

interface Args {
  form: $TSFixMe;
  value?: string;
  defaultValue: string;
  onUpdate: (value: string) => void;
}

export default class PhoneHandoverGoodbyeMessage extends Component<Args> {
  get goodbyeMessage(): string | undefined {
    return this.args.value;
  }

  set goodbyeMessage(value: string | undefined) {
    if (value !== undefined) {
      this.args.onUpdate(value);
    }
  }

  get isModified(): boolean {
    return (
      this.args.value !== undefined && this.args.value.trim() !== this.args.defaultValue.trim()
    );
  }

  @action
  resetToDefault() {
    this.args.onUpdate(this.args.defaultValue);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Sections::NumberConfiguration::PhoneHandover::PhoneHandoverGoodbyeMessage': typeof PhoneHandoverGoodbyeMessage;
  }
}
